import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import {
  StoreManagementAuthStoreCreateParams,
  StoreManagementAuthStoreCreateResponse,
} from '@/services/StoreManagement/AuthStores/hooks/create/useStoreManagementAuthStoreCreate';

import {
  StoreManagementAuthStore,
  StoreManagementAuthStoreShowReqponse,
  StoreManagementAuthStoreUpdateParams,
  StoreManagementSearchListParams,
  StoreManagementSearchListResponse,
} from './hooks';

interface Interface {
  searchList: (
    params: StoreManagementSearchListParams
  ) => Promise<StoreManagementSearchListResponse>;
  list: () => Promise<StoreManagementAuthStore[]>;
  show: (id: number) => Promise<StoreManagementAuthStoreShowReqponse>;
  update: (
    id: number,
    params: StoreManagementAuthStoreUpdateParams
  ) => Promise<void>;
  create: (
    params: StoreManagementAuthStoreCreateParams
  ) => Promise<StoreManagementAuthStoreCreateResponse>;
}

export class StoreManagementStoreService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async searchList(
    params: StoreManagementSearchListParams
  ): Promise<StoreManagementSearchListResponse> {
    const queryParams = new URLSearchParams();
    queryParams.append('limit', String(params.limit));
    queryParams.append('current_page', String(params.currentPage));
    if (params.name !== '') queryParams.append('name', String(params.name));
    return await this.restClient.get<StoreManagementSearchListResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/auth-stores?${queryParams.toString()}` as const
    );
  }

  public async list(): Promise<StoreManagementAuthStore[]> {
    return await this.restClient.get<StoreManagementAuthStore[]>(
      `${TABLET_API_ORIGIN}/dashboard-api/auth-stores/list` as const
    );
  }

  public async show(id: number): Promise<StoreManagementAuthStoreShowReqponse> {
    return await this.restClient.get<StoreManagementAuthStoreShowReqponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/auth-stores/${id}` as const
    );
  }

  public async update(
    id: number,
    params: StoreManagementAuthStoreUpdateParams
  ): Promise<void> {
    return await this.restClient.patch(
      `${TABLET_API_ORIGIN}/dashboard-api/auth-stores/${id}` as const,
      params
    );
  }

  public async create(
    params: StoreManagementAuthStoreCreateParams
  ): Promise<StoreManagementAuthStoreCreateResponse> {
    return await this.restClient.post(
      `${TABLET_API_ORIGIN}/dashboard-api/auth-stores` as const,
      params
    );
  }

  public async delete(id: number): Promise<void> {
    return await this.restClient.delete(
      `${TABLET_API_ORIGIN}/dashboard-api/auth-stores/${id}` as const
    );
  }
}
